import { render, staticRenderFns } from "./PosRole.vue?vue&type=template&id=6d860fe6&scoped=true"
import script from "./PosRole.vue?vue&type=script&lang=js"
export * from "./PosRole.vue?vue&type=script&lang=js"
import style0 from "./PosRole.vue?vue&type=style&index=0&id=6d860fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d860fe6",
  null
  
)

export default component.exports